import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { withRouter, useLocation, Redirect } from 'react-router-dom'
import { bindActionCreators } from 'redux'
// import welcomeImage from './styles/images/launchdeck-new-user-welcome.png'

import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputLeftAddon,
  Image,
  InputRightElement,
  Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverHeader, useDisclosure,
  useOutsideClick,
  useMediaQuery,
  useToast
} from "@chakra-ui/react";
import PageLoader from '../global/components/helper-components/components/PageLoader';
import SearchIcon from './styles/images/search-icon.svg';
import VaultDisplayDsrModule from './VaultDisplayDsrModule';
import { vaultSearch } from './actions/vault-actions';
import VaultDisplaySearchResultsModule from './VaultDisplaySearchResultsModule';

import { GoChevronDown } from 'react-icons/go';
import { IoMdAddCircle, IoIosClose } from 'react-icons/io';
import { checkIfDismissedBanner, redirectToNewPage, triggerLaunchdeckToast } from '../global/helpers/global-helpers';
import VaultMobileNavMenu from './VaultMobileNavMenu';
import OnboardingModal from '../new-user-experience/components/OnboardingModal';
import { getUserProfile, getUserSettings, updateUserActionEvent } from '../profile/actions/users-profile-actions';
import DynamicAppBannerDisplay from '../global/components/helper-components/components/DynamicAppBannerDisplay';
import LoggedOutConfirmationModal from '../digital-sales-room/dsr-general-mgmt/LoggedOutConfirmationModal';
import { determineIsNonCustomerUserAccount } from '../profile/helpers/user-helper';
import { changeDsrModalState, changeDsrPopupState } from '../digital-sales-room/actions/dsr-actions';
import DsrDynamicModal from '../digital-sales-room/messages/DsrDynamicModal';
import { resetUpdateDsrTemplateOutcome } from '../digital-sales-room/actions/dsr-template-actions';
import { clearGenAiRoomReadyNotification, resetCreateGenAiRoom } from '../digital-sales-room/actions/dsr-gen-ai-actions';
import "driver.js/dist/driver.css";
import { driver } from "driver.js";
import { setIsNewUserTour } from '../new-user-experience/actions/onboarding-actions';
import NewUserTourStartModal from '../new-user-experience/components/NewUserTourStartModal';

function VaultPage({
  vaultIsProcessing,
  allUserDsrs,
  fetchVaultData,
  vaultSearchResults,
  vaultSearchIsProcessing,
  resetFetchVaultData,
  isMobileView,
  userPrivileges,
  // Actions
  vaultSearch,
  getUserSettings,
  getUserProfile,
  changeDsrPopupState,
  changeDsrModalState,
  resetUpdateDsrTemplateOutcome,
  clearGenAiRoomReadyNotification,
  resetCreateGenAiRoom,
  setIsNewUserTour,
  updateUserActionEvent,
  // Redux states
  userAccountProfile,
  userSettings,
  isOrgAdmin,
  userActionRequiredState,
  showDsrModalState,
  updateDsrTemplateOutcome,
  notifyGenAiRoomReady,
  genAiRoomReadyNotification,
  updateDsrOutcome,
  newUserTourIsActive
}) {

  const initRef = useRef(false);
  const location = useLocation();

  const [localState, setLocalState] = useState({
    isLoading: true,
    isVerified: null,
    isEmptyState: '',
    requestCategory: "initialize",

    //Data Mgmt
    displayedDsrs: "",

    // UX Management
    showCreateDsrModal: "",
    itemsPerPage: 9, // TODO: Allow user configurability
    pageNumber: 1,
    modalTransferPayload: ""
  })

  const isNoOrgUser = determineIsNonCustomerUserAccount();
  const toast = useToast();

  // Manage banner
  const [showAlertBanner, setShowAlertBanner] = useState(false)
  const [offerFreeTrial, setOfferFreeTrial] = useState(false)
  const [freeTrialCode, setFreeTrialCode] = useState("")

  // Manage search bar
  const [displaySearchResults, setDisplaySearchResults] = useState(false)
  const [searchInputValue, setSearchInputValue] = useState("");

  // Manage Tab status
  const [chosenStatusTab, setChosenStatusTab] = useState("published")

  // Manage Sort function
  const [showSortDropdown, setShowSortDropdown] = useState(false)
  const [chosenSortValue, setChosenSortValue] = useState("Latest")

  // Mange Filter function
  const [showFilterDropdown, setShowFilterDropdown] = useState(false)
  const [chosenFilterValue, setChosenFilterValue] = useState("All Rooms")

  // Onboarding UX
  const [showStartNewUserTourModal, setShowStartNewUserTourModal] = useState(false)
  const [showNewUserMobileWelcome, setShowNewUserMobileWelcome] = useState(false)
  const [showOnboardingModal, setShowOnboardingModal] = useState(false) // UUU TODO: Review this against the new driver tour
  const [disableDraftDsrDisplay, setDisableDraftDsrDisplay] = useState(false)
  const [showDemoUserSelfOnboardingModal, setShowDemoUserSelfOnboardingModal] = useState(false)
  const [newUserTourCompleted, setNewUserTourCompleted] = useState(false)

  // Free Trial UX
  const [restrictAddingRoom, setRestrictAddingRoom] = useState(false)
  const [remainingAssets, setRemainingFreeAssets] = useState("")

  // Gen AI Notification UX
  const [startClearNotificationTimer, setStartClearNotificationTimer] = useState(false)

  // General UX
  const [publishedDsrs, setPublishedDsrs] = useState([])
  const [unpublishedDsrs, setUnpublishedDsrs] = useState([])
  

  useEffect(() => {
    if (!initRef.current) {
      document.title = 'Launchdeck Digital Sales Room'
      document.description =
        'Create customised private digital sales rooms that let Sales & Purchasing teams agree on deals quickly'


      if (isNoOrgUser === true) {
        redirectToNewPage(`/received-rooms`)
      } else {
        fetchVaultData({ requestCategory: "initialize", pageNumber: 1, itemsPerPage: localState.itemsPerPage, sortRequest: "default" })
      }
      initRef.current = true
    }
  }, [fetchVaultData, localState.itemsPerPage, isNoOrgUser])

  useEffect(() => {
    if (updateDsrTemplateOutcome) {
      const { updateDsrTemplateStatus, sourceEvent } = updateDsrTemplateOutcome || {}

      if (updateDsrTemplateStatus === "success") {
        switch (sourceEvent) {
          case ("delete-dsr-template"): {
            // UUU Get this to use the current filters
            // Determine if this is searched
            // In thie case, the chosenStatusTab === "templates" by default
            let retainRequestCategory = "";

            if (displaySearchResults === true) {
              onTextSearch({ query: searchInputValue, pickedDsrStatus: chosenStatusTab, pickedSortValue: chosenSortValue })
            } else {
              switch (chosenFilterValue) {
                case ("All Rooms"): {
                  retainRequestCategory = "active-templates"
                  break;
                }
                case ("Owned by me"): {
                  retainRequestCategory = "user-private-templates"
                  break;
                }
                default: {
                  retainRequestCategory = "initialize"
                  break;

                }
              }
              fetchVaultData({ requestCategory: retainRequestCategory, pageNumber: 1, itemsPerPage: localState.itemsPerPage, sortRequest: chosenSortValue })
            }


            break;
          }
          default: {
            break;
          }
        }

        resetUpdateDsrTemplateOutcome()
      }

      // if (isNoOrgUser === true) {
      //   redirectToNewPage(`/received-rooms`)
      // } else {
      //   fetchVaultData({ requestCategory: "initialize", pageNumber: 1, itemsPerPage: localState.itemsPerPage, sortRequest: "default" })
      // }
      // initRef.current = true
    }
  }, [fetchVaultData, updateDsrTemplateOutcome])

  useEffect(() => {
    if (!userAccountProfile) {
      getUserProfile({
        getOrgProfile: true
      })
    } else {
      const { userMetaData } = userAccountProfile || {};
      const { productMarketing, onboarding } = userMetaData || {};
      
      const {showNewUserTour, showMobileNewUserWelcome} = onboarding || {};
      const { offerFreeTrial, freeTrialCode } = productMarketing || {};

      if (showNewUserTour) {
          showMobileNewUserWelcome && isMobileView && setShowNewUserMobileWelcome(showMobileNewUserWelcome)
          setShowStartNewUserTourModal(true)
      }

      if (offerFreeTrial && freeTrialCode) {
        setOfferFreeTrial(true)
        setFreeTrialCode(freeTrialCode)
      }
    }
  }, [userAccountProfile, getUserProfile])

  useEffect(() => {
    if (!userSettings) {
      getUserSettings({ emailSettingsRequest: false, bannerSettingsRequest: true, checkDemoSignupUserRequest: false })
    } else if (userSettings && userPrivileges.subscriptionReminder === true) {

      const requiredBannerType = isOrgAdmin ? "org-admin-subscribe-reminder" : ""

      if (requiredBannerType) {
        const isDismissedBanner = checkIfDismissedBanner(userSettings, requiredBannerType)

        if (!!isDismissedBanner) {
          setShowAlertBanner(false)
        } else {
          setShowAlertBanner(true)
        }
      }
    }

  }, [userSettings, getUserSettings, isOrgAdmin, userPrivileges.subscriptionReminder])

  useEffect(() => {
    if (allUserDsrs) {
      const { isVerified, isNoOrgUser, foundDsrsTotal, displayedDsrs, disableDraftDisplay, isDisplayTemplates, maxRoomLimitReached, freeRemainingAssets } = allUserDsrs || {};
      const isEmptyState = displayedDsrs ? false : true;

      if (typeof maxRoomLimitReached === 'boolean') {
        (freeRemainingAssets >=0 && Array.isArray(displayedDsrs)) && displayedDsrs?.unshift({showNudgeCard: true, freeRemainingAssets})
        setRestrictAddingRoom(maxRoomLimitReached)
        setRemainingFreeAssets(freeRemainingAssets)
      }

      if (isNoOrgUser === true) {
        redirectToNewPage('/received-rooms')
      } else {
        setLocalState((localState) => ({
          ...localState,
          isLoading: false,
          isVerified,
          isEmptyState,
          displayedDsrs,
          foundDsrsTotal,
          isDisplayTemplates
        }))

        if (!!disableDraftDisplay) {
          setDisableDraftDsrDisplay(true)
        }

        resetFetchVaultData()
      }
    }
  }, [allUserDsrs, resetFetchVaultData])

  useEffect(() => {
    if (location.state) {
      const { showGenesisOnboarding, selfOnboardedSuccess } = location.state || {}

      if (!!showGenesisOnboarding) {
        setShowOnboardingModal(true)
      } else if (!!selfOnboardedSuccess) {

        setShowDemoUserSelfOnboardingModal(true)
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (notifyGenAiRoomReady && genAiRoomReadyNotification) {
      const { dsrTitle, redirectUrl } = genAiRoomReadyNotification || {}

      toast(
        triggerLaunchdeckToast({
          useCase: "show-success-state",
          bannerText: `${dsrTitle} is now ready`,
          label: `Now available in your drafts`,
          duration: 7200,
          link: redirectUrl,
          linkText: `See it now`,
          isMobileView
        })
      )

      resetCreateGenAiRoom()
      setStartClearNotificationTimer(true)
    }
  }, [notifyGenAiRoomReady, genAiRoomReadyNotification])

  useEffect(() => {
    if (startClearNotificationTimer) {
      const timer = setTimeout(() => {
        clearGenAiRoomReadyNotification()
        setStartClearNotificationTimer(false);
      }, 7200); // Hide the error message after 7.2 seconds

      return () => clearTimeout(timer);
    }
  }, [startClearNotificationTimer, clearGenAiRoomReadyNotification]);

  useEffect(()=>{
    if (updateDsrOutcome) {
      const {updateDsrStatus, updatedDsrId, sourceEvent} = updateDsrOutcome || {}
      if (sourceEvent==="revert-dsr-to-draft") {
        if (!!updateDsrStatus) {
          setUnpublishedDsrs(prevState=> [...prevState, updatedDsrId])

          if (remainingAssets >= 0) {
            setRemainingFreeAssets(prevState => {
                return prevState + 1
            })
          }
        }
      } else if (sourceEvent==="republish-dsr") {
        if (!!updateDsrStatus) {
          setPublishedDsrs(prevState=> [...prevState, updatedDsrId])

          if (remainingAssets > 0) {
            setRemainingFreeAssets(prevState => {
                return prevState - 1
            })
          }
        }
      }
    }
  },[updateDsrOutcome, remainingAssets])

  useEffect(()=>{
    if (!!disableDraftDsrDisplay && unpublishedDsrs.length > 0) {
      setDisableDraftDsrDisplay(false)
    }
  },[unpublishedDsrs, disableDraftDsrDisplay])

  const toggleFilter = (requestCategory, pageNumber, sortRequest, customQueryDimension) => {
    if (requestCategory) {
      setLocalState({
        ...localState,
        requestCategory,
        pageNumber,
        displayedDsrs: ""
      })

      fetchVaultData({
        requestCategory,
        sortRequest: sortRequest ? sortRequest : "default",
        pageNumber: pageNumber ? pageNumber : 1,
        itemsPerPage: parseInt(localState.itemsPerPage),
        customQueryDimension: customQueryDimension ? customQueryDimension : ""
      })

      setDisplaySearchResults(false)
    } else if (!requestCategory) {
      setLocalState({
        ...localState,
        requestCategory: "initialize",
        pageNumber
      })

    }
  }

  const onTextSearch = ({ query, pickedDsrStatus, pickedDsrOwnership, customQueryDimension }) => {

    let requiredDsrOwnership = "all-dsrs";
    let requiredDsrStatus = "active-only"

    switch (pickedDsrOwnership) {
      case ("All Rooms"): {
        requiredDsrOwnership = "all-dsrs"
        break;
      }
      case ("Owned by me"): {
        requiredDsrOwnership = "owned-by-user-only"
        break;
      }
      default: {
        if (chosenFilterValue) {
          requiredDsrOwnership = (chosenFilterValue === "Owned by me") ? "owned-by-user-only" : "all-dsrs"
        }
        break;
      }
    }

    switch (pickedDsrStatus) {
      case ("drafts"): {
        requiredDsrStatus = "draft-only"
        break;
      }
      case ("published"): {
        requiredDsrStatus = "active-only"
        break;
      }
      case ("templates"): {
        requiredDsrStatus = "templates-only"
        break;
      }
      default: {
        if (chosenStatusTab === "drafts") {
          requiredDsrStatus = "draft-only"
        }
        break;
      }
    }

    const searchDsrMetadata = {
      queryInput: query,
      requiredDsrStatus,
      requiredDsrOwnership,
      customQueryDimension,
      searchTemplates: (pickedDsrStatus === "templates" || requiredDsrStatus === "templates-only") ? true : false
    }

    setDisplaySearchResults(true)
    vaultSearch(searchDsrMetadata)
  }

  const resetCardPublishStatus = () => {
    setPublishedDsrs([])
    setUnpublishedDsrs([])
  }

  const onClickCreateDsr = () => {
    changeDsrPopupState('create-new-room-form')
    changeDsrModalState(true)
  }

  const handleCloseOnboardingModal = () => {
    setShowOnboardingModal(false)
    setShowDemoUserSelfOnboardingModal(false)
  }

  const resetAllFilterValues = () => {
    setChosenFilterValue("All Rooms")
    setChosenSortValue("Latest")
    resetCardPublishStatus()
  }

  const handleDsrModalClose = () => {
    changeDsrPopupState('')
    changeDsrModalState(false)

    setLocalState((prevState) => ({
      ...prevState,
      modalTransferPayload: ""
    }))
  }

  const handleChangeUserActionRequired = (newUserActionRequired, modalTransferPayload) => {
    changeDsrPopupState(newUserActionRequired)
    changeDsrModalState(true)
    setLocalState((prevState) => ({
      ...prevState,
      modalTransferPayload,
    }))
  }

  const onClickSubscriptionNudge = () => {
    handleChangeUserActionRequired('subscription-nudge',{
      titleText: `⚡ Go Unlimited Rooms`,
      copyText:"Plus...detailed sales intelligence & collaborate with coworkers easily"
    })
  }

  const handleClearSearch = () => {
    if (chosenStatusTab === "templates") {
      toggleFilter("active-templates", 1, "default")
      setDisplaySearchResults(false)
      setSearchInputValue("")
      resetAllFilterValues()
    } else if (chosenStatusTab === "drafts") {
      toggleFilter("host-team-draft-dsr", 1, "default")
      setDisplaySearchResults(false)
      setSearchInputValue("")
      resetAllFilterValues()
    } else {
      toggleFilter("initialize", 1, "default")
      setDisplaySearchResults(false)
      setSearchInputValue("")
      resetAllFilterValues()
    }
  }


  const renderVaultPageDisplay = () => {
    const { isLoading, foundDsrsTotal, itemsPerPage, pageNumber, requestCategory,
      isOnboarded, isEmptyState, displayedDsrs, allOrgSharedTemplates } = localState;

    if (isLoading === true) {
      return <PageLoader />
    }
    else if (isLoading === false) {
      if (isOnboarded === false) {
        return <Redirect to={'/welcome'} />
      }


      if (isEmptyState === false || isEmptyState === null) {
        if (displaySearchResults === true) {
          return (
            <React.Fragment>
              <VaultSearchToolbar
                onTextSearch={onTextSearch}
                onClickCreateDsr={onClickCreateDsr}
                showSortDropdown={showSortDropdown}
                setShowSortDropdown={setShowSortDropdown}
                chosenSortValue={chosenSortValue}
                setChosenSortValue={setChosenSortValue}
                showFilterDropdown={showFilterDropdown}
                setShowFilterDropdown={setShowFilterDropdown}
                chosenFilterValue={chosenFilterValue}
                setChosenFilterValue={setChosenFilterValue}
                chosenStatusTab={chosenStatusTab}
                setChosenStatusTab={setChosenStatusTab}
                searchInputValue={searchInputValue}
                setSearchInputValue={setSearchInputValue}
                isMobileView={isMobileView}
                disableDraftDsrDisplay={disableDraftDsrDisplay}
                handleClearSearch={handleClearSearch}
                restrictAddingRoom={restrictAddingRoom}
                resetCardPublishStatus={resetCardPublishStatus}
              />
              <Box className="display-dsr-container">
                <VaultDisplaySearchResultsModule
                  vaultSearchResults={vaultSearchResults}
                  itemsPerPage={itemsPerPage}
                  currentPageNumber={pageNumber}
                  isMobileView={isMobileView}
                  vaultSearchIsProcessing={vaultSearchIsProcessing}
                  chosenSortValue={chosenSortValue}
                  chosenFilterValue={chosenFilterValue}
                  chosenStatusTab={chosenStatusTab}
                  handleClearSearch={handleClearSearch}
                  handleDuplicateDsrModal={handleChangeUserActionRequired}
                  handleDeleteDsrTemplateModal={handleChangeUserActionRequired} // TODO: Refactor, combine into one function with handleDuplciateDsrModal?
                  handleChangeUserActionRequired={handleChangeUserActionRequired}
                  publishedDsrs={publishedDsrs}
                  unpublishedDsrs={unpublishedDsrs}
                />
              </Box>

              <DsrDynamicModal
                showDsrModal={showDsrModalState}
                userActionRequired={userActionRequiredState}
                handleDsrModalClose={handleDsrModalClose}
                modalTransferPayload={localState.modalTransferPayload}
              />
            </React.Fragment>
          )
        } else {
          return (
            <React.Fragment>
              <VaultToolbar
                displaySearchResults={displaySearchResults}
                toggleFilter={toggleFilter}
                onTextSearch={onTextSearch}
                onClickCreateDsr={onClickCreateDsr}
                pageNumber={localState.pageNumber}
                requestCategory={localState.requestCategory}
                showSortDropdown={showSortDropdown}
                setShowSortDropdown={setShowSortDropdown}
                chosenSortValue={chosenSortValue}
                setChosenSortValue={setChosenSortValue}
                showFilterDropdown={showFilterDropdown}
                setShowFilterDropdown={setShowFilterDropdown}
                chosenFilterValue={chosenFilterValue}
                setChosenFilterValue={setChosenFilterValue}
                chosenStatusTab={chosenStatusTab}
                setChosenStatusTab={setChosenStatusTab}
                searchInputValue={searchInputValue}
                setSearchInputValue={setSearchInputValue}
                isMobileView={isMobileView}
                disableDraftDsrDisplay={disableDraftDsrDisplay}
                restrictAddingRoom={restrictAddingRoom}
                resetCardPublishStatus={resetCardPublishStatus}
              />
              <Box className="display-dsr-container">
                <VaultDisplayDsrModule
                  requestCategory={requestCategory}
                  displayedDsrs={displayedDsrs}
                  isMobileView={isMobileView}
                  vaultIsProcessing={vaultIsProcessing}
                  foundDsrsTotal={foundDsrsTotal}
                  itemsPerPage={itemsPerPage}
                  toggleFilter={toggleFilter}
                  currentPageNumber={pageNumber}
                  vaultSearchIsProcessing={vaultSearchIsProcessing}
                  chosenSortValue={chosenSortValue}
                  onClickCreateDsr={onClickCreateDsr}
                  handleDuplicateDsrModal={handleChangeUserActionRequired}
                  handleCreateDsrTemplateModal={handleChangeUserActionRequired} // TODO: Refactor, combine into one function with handleDuplciateDsrModal?
                  handleDeleteDsrTemplateModal={handleChangeUserActionRequired}
                  chosenStatusTab={chosenStatusTab}
                  chosenFilterValue={chosenFilterValue}
                  allOrgSharedTemplates={allOrgSharedTemplates}
                  handleClearSearch={handleClearSearch}
                  onClickHowToCreateTemplate={() => handleChangeUserActionRequired("show-create-template-tutorial-modal", {})}
                  onClickSubscriptionNudge={onClickSubscriptionNudge}
                  remainingAssets={remainingAssets}
                  handleChangeUserActionRequired={handleChangeUserActionRequired}
                  publishedDsrs={publishedDsrs}
                  unpublishedDsrs={unpublishedDsrs}
                />
              </Box>

              <DsrDynamicModal
                showDsrModal={showDsrModalState}
                userActionRequired={userActionRequiredState}
                handleDsrModalClose={handleDsrModalClose} // UUU fake, swap this out
                modalTransferPayload={localState.modalTransferPayload}
              />
            </React.Fragment>
          )
        }
      }
    }
  }

  const handleStartTour = () => {
    setIsNewUserTour(true)
    setShowStartNewUserTourModal(false)
  }

  const handleDismissMobileWelcome = () => {
    setShowStartNewUserTourModal(false)
    updateUserActionEvent({
      event: 'new-user-mobile-welcome-viewed',
      payload: null,
    })
  }

  useEffect(()=>{
    if(newUserTourIsActive && !isMobileView) {
      const handleRegisterTourCompleted = () => {
        updateUserActionEvent({
          event: 'new-user-tour-completed',
          payload: null,
        })
      }

      const driverObj = driver({
        showProgress: true,
        allowClose: false,
        showButtons: ['next'],
        overlayColor: "rgba(0, 0, 0, 0.5)",
        onDestroyed: () => {
          setIsNewUserTour(false)
          setNewUserTourCompleted(true)
        },
        onReset: () => setIsNewUserTour(false),
        // onHighlighted: () => setIsNewUserTour(true),
        steps: [
          {
            element: '[data-driver="step-1"]',
            popover: { 
              title: "Get what you need quickly", 
              description: `
              <div>
              <div style="margin-bottom: 1em;">Rooms, Prospectors, and Rooms you're invited into have been organised separately for clarity. </div>
              <div>Use this menu to find what you need quickly. </div>
             
              </div>
              `}
          },
          {
            element: '[data-driver="step-2"]',
            popover: { title: "Your personal menu", description: "If you need to edit your profile, or seek support, this is the place for it.",
              onNextClick: () => {
                onClickCreateDsr()
                driverObj.moveNext();
              },
            },
          },
          {
            element: '[data-driver="step-3"]',
            popover: { title: "Creating Rooms", 
              description: "It’s never been easier. First, click here…"},
          },
          {
            element: '[data-driver="step-4"]',
            popover: { title: "Describe what it's about", description: "... fill up a few things along the way, and a draft Room will be created in no time."},
          
          },
          {
            element: '[data-driver="step-5"]',
            popover: { title: "Or, create a draft with existing materials", description: "Feed your documents and let our AI create a draft to simplify things further!",
              onNextClick: () => {
                handleRegisterTourCompleted()
                handleDsrModalClose()
                driverObj.moveNext();
              },
            },
          },
          {
            element: '[data-driver="closer"]',
            popover: { title: "You are good to go!", 
              description: `<div><div>There'll be additional support for specific things, just click on "?" icons. There's also always the option to contact us directly for help</div><div style="margin-top: 0.5em;">Now, try creating your first Room</div></div>`,
            },
          },
        ]
      });
  
      driverObj.drive()
    }
   
  },[newUserTourIsActive, isMobileView])



  return (
    <React.Fragment>
      {showAlertBanner && !isNoOrgUser && <DynamicAppBannerDisplay bannerType={offerFreeTrial ? "free-trial-subscribe-nudge" : "subscription-nudge"} freeTrialCode={freeTrialCode} />}
      <Box>
        {renderVaultPageDisplay()}
      </Box>
      <Box>
        {showStartNewUserTourModal &&
        <NewUserTourStartModal
        isMobileView = {isMobileView}
        handleStartTour={handleStartTour}
        handleDismissMobileWelcome={handleDismissMobileWelcome}
        newUserTourIsActive={newUserTourIsActive}
        newUserTourCompleted={newUserTourCompleted}
        showNewUserMobileWelcome={showNewUserMobileWelcome}
        />
}
        <OnboardingModal
          showModal={showOnboardingModal ? showOnboardingModal : showDemoUserSelfOnboardingModal}
          handleCloseModal={handleCloseOnboardingModal}
          handleCreateFirstRoom={onClickCreateDsr}
          contentType={showOnboardingModal ? "genesis" : showDemoUserSelfOnboardingModal && "demo-user-self-onboarding"}
        />
        <LoggedOutConfirmationModal />
      </Box>
    </React.Fragment>

  )
}

function VaultToolbar({ toggleFilter, onTextSearch, onClickCreateDsr, requestCategory, pageNumber,
  showSortDropdown, setShowSortDropdown, chosenSortValue, setChosenSortValue,
  showFilterDropdown, setShowFilterDropdown, chosenFilterValue, setChosenFilterValue,
  chosenStatusTab, setChosenStatusTab,
  searchInputValue, setSearchInputValue,
  isMobileView, disableDraftDsrDisplay, restrictAddingRoom, resetCardPublishStatus
}) {


  const { isOpen, onToggle, onClose } = useDisclosure()
  const ownerDropdownRef = useRef(null);
  const sortOrderDropdownRef = useRef(null);

  const isTemplatesFilter = (chosenStatusTab === 'templates') ? true : false;
  const isDraftFilter = (chosenStatusTab === 'drafts') ? true : false;
  const isPublishedFilter = (chosenStatusTab === 'published' || chosenStatusTab === '') ? true : false;
  const [isError, setIsError] = useState(false);
  const [isLargerThan1000] = useMediaQuery('(min-width: 1000px)')

  useOutsideClick({
    ref: ownerDropdownRef,
    handler: () => setShowFilterDropdown(false),
  })

  useOutsideClick({
    ref: sortOrderDropdownRef,
    handler: () => setShowSortDropdown(false),
  })


  const handleChange = (event) => {
    setSearchInputValue(event.target.value)
    isError && setIsError(false)
  }


  const handleEnter = (event) => {
    if (event.key === 'Enter' && event.target.name === "vault-page-search-bar") {
      if (searchInputValue.trim().length > 2) {
        onTextSearch({
          query: searchInputValue,
          pickedSortValue: chosenSortValue,
          pickedDsrStatus: chosenStatusTab,
          pickedDsrOwnership: chosenFilterValue
        })
        onClose()
      } else {
        setIsError(true)
        onToggle()
      }
    }
  }

  const handlePickSortOption = (option) => {
    let sortRequest = "default";
    let customQueryDimension = "";

    switch (option) {
      case ('Latest'): {
        sortRequest = "latest"
        break;
      }
      case ('Room name (A - Z)'): {
        sortRequest = "a-to-z"
        break;
      }
      case ('Room name (Z - A)'): {
        sortRequest = "z-to-a"
        break;
      }
      case ('Deal Value'): {
        sortRequest = ""
        customQueryDimension = {
          queryDimension: "dealValue",
          dimensionValue: 0,
          comparison: "descending"
        }
        break;
      }
      default: {
        break;
      }
    }
    if (option) {
      setChosenSortValue(option)
      toggleFilter(requestCategory, pageNumber, sortRequest, customQueryDimension)
    }
  }

  const handlePickDsrStatusTab = (pickedTab) => {

    if (pickedTab) {
      let sortRequest = "default";
      let requestCategory = "default";
      let customQueryDimension = "";

      switch (chosenFilterValue) {
        case ("All Rooms"): {
          if (pickedTab === "published") {
            requestCategory = "host-team-active-dsr";
          } else if (pickedTab === "drafts") {
            requestCategory = "host-team-draft-dsr";
          } else if (pickedTab === "templates") {
            requestCategory = "active-templates";
          }

          break;
        }
        case ("Owned by me"): {
          if (pickedTab === "published") {
            requestCategory = "user-owned-active-dsr";
          } else if (pickedTab === "drafts") {
            requestCategory = "user-owned-draft-dsr";
          } else if (pickedTab === "templates") {
            requestCategory = "user-private-templates";
          }
          break;
        }
        default: {

          break;
        }
      }

      switch (chosenSortValue) {
        case ('Latest'): {
          sortRequest = "latest"
          break;
        }
        case ('Room name (A - Z)'): {
          sortRequest = "a-to-z"
          break;
        }
        case ('Room name (Z - A)'): {
          sortRequest = "z-to-a"
          break;
        }
        case ('Deal Value'): {
          sortRequest = "deal-value-descending";
          customQueryDimension = {
            queryDimension: "dealValue",
            dimensionValue: 0,
            comparison: "descending"
          }
          break;
        }
        default: {
          break;
        }
      }

      setChosenStatusTab(pickedTab)
      resetCardPublishStatus()
      toggleFilter(requestCategory, pageNumber, sortRequest, customQueryDimension)
    }
  }

  const handlePickFilterOption = (filterOption) => {
    if (filterOption) {
      let sortRequest = "default";
      let requestCategory = "default";
      let customQueryDimension = "";

      switch (chosenSortValue) {
        case ('Latest'): {
          sortRequest = "latest"
          break;
        }
        case ('Room name (A - Z)'): {
          sortRequest = "a-to-z"
          break;
        }
        case ('Room name (Z - A)'): {
          sortRequest = "z-to-a"
          break;
        }
        case ('Deal Value'): {
          sortRequest = "deal-value-descending"
          customQueryDimension = {
            queryDimension: "dealValue",
            dimensionValue: 0,
            comparison: "descending"
          }
          break;
        }
        default: {
          break;
        }
      }

      switch (filterOption) {
        case ("All Rooms"): {
          if (chosenStatusTab === "published") {
            requestCategory = "host-team-active-dsr";
          } else if (chosenStatusTab === "drafts") {
            requestCategory = "host-team-draft-dsr";
          } else if (chosenStatusTab === "templates") {
            requestCategory = "active-templates";
          }

          break;
        }
        case ("Owned by me"): {
          if (chosenStatusTab === "published") {
            requestCategory = "user-owned-active-dsr";
          } else if (chosenStatusTab === "drafts") {
            requestCategory = "user-owned-draft-dsr";
          } else if (chosenStatusTab === "templates") {
            requestCategory = "user-private-templates";
          }
          break;
        }
        default: {

          break;
        }
      }

      setChosenFilterValue(filterOption)
      toggleFilter(requestCategory, pageNumber, sortRequest, customQueryDimension)
    }

  }

  return (
    <>
      {!isLargerThan1000 ?
        <VaultMobileNavMenu currentMode="dsr" />
        :
        <Flex w='100%' justify='space-between' align='center'>
          <React.Fragment>
            <Box>
              <Box className="page-title" >Rooms</Box>
              <Box fontSize='0.8em'> Engage teams of audiences with customised content & private discussions </Box>
            </Box>
            {!restrictAddingRoom &&
              <Box whiteSpace='nowrap' data-driver="step-3">
                <Flex className='create-new-room-button'
                  onClick={() => onClickCreateDsr()}>
                  <Box className='create-new-room-button__button-text'>New Room</Box>
                  <Box as={IoMdAddCircle} boxSize='1.5em' className='create-new-room-button__add-icon' />
                </Flex>
              </Box>
            }
          </React.Fragment>
        </Flex>
      }
      <Flex justifyContent='center' style={{ gap: '10px' }} flexDirection={['column', 'column', 'row', 'row']} className='menu-bar'>
        <Flex fontSize={isMobileView && '0.875em'} justifyContent={['center', 'center', 'flex-start', 'flex-start']} align='center' w='100%' mb={isMobileView && '1em'} >
          <Box
            className={isPublishedFilter ? "chosen-category-tab" : "unchosen-category-tab"}
            onClick={() => !isPublishedFilter && handlePickDsrStatusTab('published')}>Published</Box>

          {disableDraftDsrDisplay ?
            <Box className="disabled-tab">
              Drafts
            </Box>
            :
            <Box
              className={isDraftFilter ? "chosen-category-tab" : "unchosen-category-tab"}
              onClick={() => !isDraftFilter && handlePickDsrStatusTab('drafts')}>
              Drafts
            </Box>
          }
          <Box
            className={isTemplatesFilter ? "chosen-category-tab" : restrictAddingRoom ? "unavailable-category-tab" : "unchosen-category-tab"}
            onClick={() => (!restrictAddingRoom && !isTemplatesFilter) && handlePickDsrStatusTab('templates')}
            >
            Templates
          </Box>
        </Flex>

        <Flex w='100%' justify='flex-end' style={{ gap: '8px' }} flexDirection={['column', 'column', 'row', 'row']} align='center'>

          <Flex className={isMobileView ? 'filter-menu-mobile':'filter-menu'} onClick={() => { setShowSortDropdown(!showSortDropdown); setShowFilterDropdown(false) }} ref={sortOrderDropdownRef}>
            <Flex>
              <Box mr='0.5em' color='gray.500' fontSize='0.875em' fontWeight='400' lineHeight='1.375em'>Sort By:</Box>
              <Box className='chosen-option-text-display'>{chosenSortValue}</Box>
            </Flex>

            <Box as={GoChevronDown} boxSize="0.75em" color="gray.300" />

            {/* Show Dropdown bar here */}
            <Box className='filter-menu__dropdown' display={showSortDropdown ? 'inline-block' : 'none'}>
              <React.Fragment>
                <Box className={(chosenSortValue !== 'Latest') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Latest') && handlePickSortOption('Latest')}>Latest</Box>
                <Box className={(chosenSortValue !== 'Room name (A - Z)') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Room name (A - Z)') && handlePickSortOption('Room name (A - Z)')}>Room name (A - Z)</Box>
                <Box className={(chosenSortValue !== 'Room name (Z - A)') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Room name (Z - A)') && handlePickSortOption('Room name (Z - A)')}>Room name (Z - A)</Box>
                {!isTemplatesFilter && <Box className={(chosenSortValue !== 'Deal Value') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Deal Value') && handlePickSortOption('Deal Value')}>Deal Value</Box>}
              </React.Fragment>
            </Box>

          </Flex>

          <Flex className={isMobileView ? 'filter-menu-mobile':'filter-menu'} ml={['0', '0', '0', '1em']} onClick={() => { setShowFilterDropdown(!showFilterDropdown); setShowSortDropdown(false) }} ref={ownerDropdownRef}>
            <Flex >
              <Box mr='0.5em' color='gray.500' fontSize='0.875em' fontWeight='400' lineHeight='1.375em'>Show:</Box>
              {(chosenStatusTab === "templates") ?
                <Box className='chosen-option-text-display'>{chosenFilterValue === 'All Rooms' ? "All Templates" : chosenFilterValue === 'Owned by me' ? "Private Templates" : ""}</Box>
                :
                <Box className='chosen-option-text-display'>{chosenFilterValue}</Box>
              }
            </Flex>

            <Box as={GoChevronDown} boxSize="0.75em" color="gray.300" />

            {/* Show Dropdown bar here */}
            <Box className='filter-menu__dropdown' display={showFilterDropdown ? 'inline-block' : 'none'}>
              <Box className={(chosenFilterValue !== 'All Rooms') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenFilterValue !== 'All Rooms') && handlePickFilterOption('All Rooms')}>{chosenStatusTab === "templates" ? "All Templates" : "All Rooms"}</Box>
              <Box className={(chosenFilterValue !== 'Owned by me') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenFilterValue !== 'Owned by me') && handlePickFilterOption('Owned by me')}>{chosenStatusTab === "templates" ? "Private templates" : "Owned by me"}</Box>
            </Box>
          </Flex>

          {/* Search bar */}
          <Popover
            isOpen={isOpen}
            onClose={onClose}
          >
            <PopoverTrigger isOpen={isError}>
              <Flex w='100%' justify='center' minWidth='max-content' maxWidth={!isMobileView && '256px'}>
                <InputGroup
                  size="2em"
                  ml={!isMobileView && "1em"}
                  width="100%"
                  maxWidth='20em'
                  borderColor='gray.300'
                  >
                  <InputLeftAddon roundedTopLeft='0.25em' roundedBottomLeft='0.25em'>
                    <Image src={SearchIcon} mx="0.75em" />
                  </InputLeftAddon>
                  <Input
                    name="vault-page-search-bar"
                    value={searchInputValue}
                    onChange={handleChange}
                    onKeyDown={handleEnter}
                    placeholder="Search"
                    padding="9px 12px"
                    rounded='0.25em'
                    fontSize='0.875em'
                    color={isError ? '#ff0000' : ''}
                  />
                  {searchInputValue && <InputRightElement children={<Box as={IoIosClose} cursor='pointer' boxSize='1em'
                    onClick={() => {
                      setSearchInputValue("")
                      isError && setIsError(false)
                    }} />} top="0" bottom="0" right="8px" m="auto" />}
                </InputGroup>
              </Flex>
            </PopoverTrigger>
            <PopoverContent zIndex={4}>
              <PopoverArrow />
              <PopoverHeader fontSize='0.875em'>Type in 3 or more characters to search</PopoverHeader>
            </PopoverContent>
          </Popover>
        </Flex>
      </Flex>
    </>

  )

}

function VaultSearchToolbar({ onTextSearch, onClickCreateDsr,
  showSortDropdown, setShowSortDropdown, chosenSortValue, setChosenSortValue,
  showFilterDropdown, setShowFilterDropdown, chosenFilterValue, setChosenFilterValue,
  chosenStatusTab, setChosenStatusTab,
  searchInputValue, setSearchInputValue,
  isMobileView, disableDraftDsrDisplay, handleClearSearch, restrictAddingRoom, resetCardPublishStatus
}) {

  const ownerDropdownRef = useRef(null);
  const sortOrderDropdownRef = useRef(null);

  const isTemplatesFilter = (chosenStatusTab === 'templates') ? true : false;
  const isDraftFilter = (chosenStatusTab === 'drafts') ? true : false;
  const isPublishedFilter = (chosenStatusTab === 'published' || chosenStatusTab === '') ? true : false;
  const [isError, setIsError] = useState(false);
  const [isLargerThan1000] = useMediaQuery('(min-width: 1000px)')

  useOutsideClick({
    ref: ownerDropdownRef,
    handler: () => setShowFilterDropdown(false),
  })

  useOutsideClick({
    ref: sortOrderDropdownRef,
    handler: () => setShowSortDropdown(false),
  })


  const handleChange = (event) => {
    setSearchInputValue(event.target.value)
    isError && setIsError(false)
  }

  const handleClearSearchText = () => {
    setSearchInputValue("")
    handleClearSearch()
    isError && setIsError(false)
  }

  const handleEnter = (event) => {
    if (event.key === 'Enter' && event.target.name === "vault-search-toolbar-two") {
      if (searchInputValue.trim().length > 2) {
        onTextSearch({
          query: searchInputValue,
          pickedDsrStatus: chosenStatusTab,
          pickedSortValue: chosenSortValue,
        })
      } else {
        setIsError(true)
      }
    }
  }

  const handlePickSortOption = (option) => {
    // let sortRequest = "default";
    let customQueryDimension = "";

    switch (option) {
      case ('Deal Value'): {
        customQueryDimension = {
          queryDimension: "dealValue",
          dimensionValue: 0,
          comparison: "descending"
        }
        break;
      }
      default: {
        break;
      }
    }

    if (option) {
      setChosenSortValue(option)
      onTextSearch({ query: searchInputValue, customQueryDimension })
    }
  }

  const handlePickDsrStatusTab = (pickedTab) => {

    if (pickedTab) {
      setChosenStatusTab(pickedTab)
      resetCardPublishStatus()
      onTextSearch({
        query: searchInputValue,
        pickedDsrStatus: pickedTab,
        pickedDsrOwnership: chosenFilterValue,
        ...((pickedTab === "templates" && chosenFilterValue === "Owned by me") && { customQueryDimension: { queryDimension: "privateTemplatesOnly" } }),
        searchTemplates: (pickedTab === "templates") ? true : false
      })
    }
  }

  const handlePickFilterOption = (filterOption) => {
    if (filterOption) {
      setChosenFilterValue(filterOption)
      onTextSearch({
        query: searchInputValue,
        pickedDsrStatus: chosenStatusTab,
        pickedDsrOwnership: filterOption,
        ...((chosenStatusTab === "templates" && filterOption === "Owned by me") && { customQueryDimension: { queryDimension: "privateTemplatesOnly" } }),
        searchTemplates: (chosenStatusTab === "templates") ? true : false
      })
    }

  }

  return (
    <>
      {!isLargerThan1000 ?
        <VaultMobileNavMenu currentMode="dsr" />
        :
        <Flex w='100%' justify='space-between' align='center'>

          <Box>
            <Box className="page-title">Rooms</Box>
            <Box fontSize='0.8em'> Engage teams of audiences with customised content & private discussions </Box>
          </Box>
          {!restrictAddingRoom && 
            <Box whiteSpace='nowrap' >
              <Flex className='create-new-room-button' onClick={() => onClickCreateDsr()}>
                <Box className='create-new-room-button__button-text'>New Room</Box>
                <Box as={IoMdAddCircle} boxSize='1.5em' className='create-new-room-button__add-icon' />
              </Flex>
            </Box>
          }

        </Flex>
      }

      <Flex style={{ gap: '10px' }} justifyContent='center' flexDirection={['column', 'column', 'row', 'row']} className='menu-bar' >
        <Flex justifyContent={['center', 'center', 'flex-start', 'flex-start']} align='center' w='100%' mb={isMobileView && '1em'} fontSize={isMobileView && '0.875em'}>
          <Box
            className={isPublishedFilter ? "chosen-category-tab" : "unchosen-category-tab"}
            onClick={() => !isPublishedFilter && handlePickDsrStatusTab('published')}>Published</Box>
          {disableDraftDsrDisplay ?
            <Box className="disabled-tab">
              Drafts
            </Box>
            :
            <Box
              className={isDraftFilter ? "chosen-category-tab" : "unchosen-category-tab"}
              onClick={() => !isDraftFilter && handlePickDsrStatusTab('drafts')}>Drafts</Box>
          }
          <Box
            className={isTemplatesFilter ? "chosen-category-tab" : restrictAddingRoom ? "unavailable-category-tab" : "unchosen-category-tab"}
            onClick={() => (!restrictAddingRoom && !isTemplatesFilter) && handlePickDsrStatusTab('templates')}>
            Templates
          </Box>
        </Flex>

        <Flex style={{ gap: '10px' }} w='100%' justify='space-around' flexDirection={['column', 'column', 'row', 'row']} align='center'>

          <Flex className={isMobileView ? 'filter-menu-mobile':'filter-menu'} onClick={() => { setShowSortDropdown(!showSortDropdown); setShowFilterDropdown(false) }} ref={sortOrderDropdownRef}>
            <Flex>
              <Box mr='0.5em' color='gray.500' fontSize='0.875em' fontWeight='400' lineHeight='1.375em'>Sort By:</Box>
              <Box className='chosen-option-text-display'>{chosenSortValue}</Box>
            </Flex>

            <Box as={GoChevronDown} boxSize="0.75em" color="gray.300" />

            {/* Show Dropdown bar here */}
            <Box className='filter-menu__dropdown' display={showSortDropdown ? 'inline-block' : 'none'}>
              <React.Fragment>
                <Box className={(chosenSortValue !== 'Latest') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Latest') && handlePickSortOption('Latest')}>Latest</Box>
                <Box className={(chosenSortValue !== 'Room name (A - Z)') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Room name (A - Z)') && handlePickSortOption('Room name (A - Z)')}>Room name (A - Z)</Box>
                <Box className={(chosenSortValue !== 'Room name (Z - A)') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Room name (Z - A)') && handlePickSortOption('Room name (Z - A)')}>Room name (Z - A)</Box>
                <Box className={(chosenSortValue !== 'Deal Value') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Deal Value') && handlePickSortOption('Deal Value')}>Deal Value</Box>
              </React.Fragment>
            </Box>

          </Flex>

          <Flex className={isMobileView ? 'filter-menu-mobile':'filter-menu'} ml={['0', '0', '0', '1em']} onClick={() => { setShowFilterDropdown(!showFilterDropdown); setShowSortDropdown(false) }} ref={ownerDropdownRef}>
            <Flex >
              <Box mr='0.5em' color='gray.500' fontSize='0.875em' fontWeight='400' lineHeight='1.375em'>Show:</Box>
              {(chosenStatusTab === "templates") ?
                <Box className='chosen-option-text-display'>{chosenFilterValue === 'All Rooms' ? "All Templates" : chosenFilterValue === 'Owned by me' ? "Private Templates" : ""}</Box>
                :
                <Box className='chosen-option-text-display'>{chosenFilterValue}</Box>
              }

            </Flex>

            <Box as={GoChevronDown} boxSize="0.75em" color="gray.300" />

            {/* Show Dropdown bar here */}
            <Box className='filter-menu__dropdown' display={showFilterDropdown ? 'inline-block' : 'none'}>

              <Box className={(chosenFilterValue !== 'All Rooms') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenFilterValue !== 'All Rooms') && handlePickFilterOption('All Rooms')}>All Rooms</Box>
              <Box className={(chosenFilterValue !== 'Owned by me') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenFilterValue !== 'Owned by me') && handlePickFilterOption('Owned by me')}>Owned by me</Box>
            </Box>
          </Flex>

          <Flex w='100%' justify='center' minWidth='max-content' maxWidth={!isMobileView && '256px'}>
            <InputGroup
              size="2em"
              ml={!isMobileView && "1em"}
              width="100%"
              maxWidth='20em'
              borderColor='gray.300'
              >
              <InputLeftAddon roundedTopLeft='0.25em' roundedBottomLeft='0.25em'>
                <Image src={SearchIcon} mx="0.75em" />
              </InputLeftAddon>
              <Input
                name="vault-search-toolbar-two"
                value={searchInputValue}
                onChange={handleChange}
                onKeyDown={handleEnter}
                placeholder="Search"
                padding="9px 12px"
                rounded='0.25em'
                fontSize='0.875em'
                color={isError ? '#ff0000' : ''}
              />
              {searchInputValue && <InputRightElement children={<Box as={IoIosClose} cursor='pointer' boxSize='1em' onClick={() => handleClearSearchText()} />} top="0" bottom="0" right="8px" m="auto" />}
            </InputGroup>
          </Flex>
          <Popover>
            <PopoverContent isOpen={isError} zIndex={4}>
              <PopoverArrow />
              <PopoverHeader fontSize='0.875em'>Type in 3 or more characters to search</PopoverHeader>
            </PopoverContent>
          </Popover>
        </Flex>
      </Flex>
    </>

  )

}

const mapStateToProps = (state) => ({
  vaultSearchResults: state.vaultSearchResults.results.data,
  vaultSearchIsProcessing: state.vaultSearchResults.isLoading,
  isMobileView: state.mobileViewMode.isMobileView,
  userPrivileges: state.userPrivileges.results,
  userAccountProfile: state.userProfile.accountUserProfile,
  isOrgAdmin: state.isOrgAdmin.results,
  userSettings: state.userSettings.results.data,
  userActionRequiredState: state.dsrPopup.UserActionRequired,
  showDsrModalState: state.dsrModal.showDsrModal,
  updateDsrTemplateOutcome: state.updateDsrTemplateOutcome.results.data,
  notifyGenAiRoomReady: state.notifyGenAiRoomReady.results,
  genAiRoomReadyNotification: state.genAiRoomReadyNotification.results,

  updateDsrOutcome: state.updateDsrOutcome.results.data,
  newUserTourIsActive: state.newUserTourIsActive.results
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      vaultSearch,
      getUserProfile,
      getUserSettings,
      changeDsrPopupState,
      changeDsrModalState,
      resetUpdateDsrTemplateOutcome,
      clearGenAiRoomReadyNotification,
      setIsNewUserTour,
      resetCreateGenAiRoom,
      updateUserActionEvent
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VaultPage))
